export const DEFAULT_COMPACT_VIEW = false;

export const PAGE_SIZE_OPTIONS = [
  {
    title: '20',
    value: '20',
  },
  {
    title: '50',
    value: '50',
  },
  {
    title: '100',
    value: '100',
  },
];
